<template>
  <div>
    <el-dialog
      :visible.sync="showDialog"
      width="700px"
      :title="`${type === 1 ? '新增' : '修改'}车间应急组`"
      v-dialogDrag
    >
      <el-form label-width="100px" :model="form" :rules="rules" ref="form">
        <!-- "workShopDirector": "顾涛",                     // 组长
        "workShopDirectorPhone": "15865421235",         // 组长手机号码
        "workShopGroupName": "一车间",                  // 车间应急组名称
        "workShopLeader": "张三",                       // 车间班组长
        "workShopLeaderPhone": "15965488520",           // 车间班组长手机号码
        "workShopTelephone": "42998521"                 // 车间固定号码 -->
        <!-- "dutyDesc ": "42998521"                 // 职责 -->
        <el-row>
          <el-col :span="12">
            <el-form-item label="应急组名称" prop="workShopGroupName">
              <el-input
                type="text"
                maxlength="30"
                placeholder="请输入"
                v-model="form.workShopGroupName"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="车间固话" prop="workShopTelephone">
              <el-input
                type="text"
                placeholder="请输入"
                v-model="form.workShopTelephone"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="组长" prop="workShopDirector">
              <el-input
                type="text"
                placeholder="请输入"
                v-model="form.workShopDirector"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="组长电话" prop="workShopDirectorPhone">
              <el-input
                type="text"
                placeholder="请输入"
                v-model="form.workShopDirectorPhone"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="班组成员" prop="workShopGroupLeaderList">
              <el-input
                type="text"
                placeholder="请选择"
                readonly
                :value="
                  form.workShopGroupLeaderList
                    .map((el) => {
                      return el.personnelName + '【' + el.personnelPhone + '】';
                    })
                    .join(',')
                "
              ></el-input>
              <el-button
                type="text"
                size="small"
                class="iconfont icon-position map-choose"
                @click="openPeople()"
              ></el-button>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="所属楼栋" prop="workShopGroupBuildingList">
              <el-input
                type="text"
                placeholder="请选择"
                :value="
                  form.workShopGroupBuildingList
                    .map((el) => {
                      if (el.buildingName) {
                        return el.parentBuildingName + '/' + el.buildingName;
                      } else {
                        return el.parentBuildingName;
                      }
                    })
                    .join(',')
                "
              ></el-input>
              <el-button
                type="text"
                size="small"
                class="iconfont icon-position map-choose"
                @click="openBuilding()"
              ></el-button>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="应急组职责" prop="dutyDesc">
              <el-input
                type="textarea"
                placeholder="请输入"
                maxlength="200"
                show-word-limit
                v-model="form.dutyDesc"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button type="info" @click="cancel">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="选择楼栋"
      width="750px"
      :visible.sync="showBuilding"
      :modal="false"
    >
      <div class="flex-container">
        <div class="flex-valign left-tree">
          <div class="left-type_area sbar">
            <!-- <div class="flex-between p10 section-mian__toolbar valign-center">
              <span>选择所属楼栋</span>
            </div> -->
            <div class="tree-container">
              <div class="area-search">
                <el-input
                  placeholder="请输入搜索关键字"
                  prefix-icon="el-icon-search"
                  v-model="searchString"
                  clearable
                >
                </el-input>
              </div>
              <div class="area-scrollbar" style="height: 500px">
                <el-scrollbar style="height: 100%; padding: 20px 0">
                  <el-tree
                    v-if="showTree"
                    ref="tree"
                    class="tree-content"
                    :data="treeData"
                    show-checkbox
                    :expand-on-click-node="false"
                    node-key="buildingCode"
                    :default-expanded-keys="expandedKeys"
                    default-expand-all
                    render-after-expand
                    :props="treeProps"
                    :highlight-current="true"
                    :filter-node-method="filterNode"
                    @check="checkChange"
                  >
                    <template slot-scope="{ node }">
                      <element-tree-line
                        :node="node"
                        :showLabelLine="true"
                        :indent="16"
                        class="tree-line"
                      >
                        <span class="custom-tree-node" style="display: block">
                          <i :class="iconList[node.type]"></i>
                          <span class="ml10 ell tree-label">{{
                            node.label
                          }}</span>
                        </span>
                      </element-tree-line>
                    </template>
                  </el-tree>
                </el-scrollbar>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--操作按钮-->
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancleOpt">取消</el-button>
        <el-button type="primary" @click="confirmOpt">确定</el-button>
      </span>
    </el-dialog>
    <!-- 人员选择 -->
    <changePeople
      @confirmCallBack="confirmCallBack"
      ref="selectPeople"
      :key="key"
      checkType="select"
    />
  </div>
</template>

<script>
import ElementTreeLine from "element-tree-line";
import changePeople from "@src/modules/buildingConfig/components/changePeople.vue";
import api from "../../api";
export default {
  components: {
    changePeople,
    ElementTreeLine,
  },
  watch: {
    searchString(val) {
      this.$refs.tree.filter(val);
    },
  },
  data() {
    return {
      workShopGroupCode: "",
      key: 0,
      iconList: {
        1: "iconfont-lunan icon-lunan-loudongguanli",
        2: "iconfont-lunan icon-lunan-louceng",
      },
      searchString: "",
      treeProps: {
        children: "subBuildingList",
        label: "buildingName",
        id: "buildingCode",
      },
      treeData: [],
      expandedKeys: [],
      buildingList: [],
      showBuilding: false,
      showTree: true,
      showDialog: false,
      form: {
        workShopGroupName: "",
        workShopDirector: "",
        workShopDirectorPhone: "",
        workShopTelephone: "",
        dutyDesc: "", //职责
        workShopGroupLeaderList: [], //负责人
        workShopGroupBuildingList: [], //楼栋
      },
      rules: {
        workShopGroupName: [
          {
            required: true,
            message: "请输入名称",
            trigger: "change",
          },
        ],
        dutyDesc: [
          {
            required: true,
            message: "请输入职责",
            trigger: "change",
          },
        ],
        workShopDirector: [
          {
            required: true,
            message: "请输入主任名称",
            trigger: "blur",
          },
        ],
        workShopGroupLeaderList: [
          {
            required: true,
            message: "请选择人员",
            trigger: "change",
          },
        ],
        workShopGroupBuildingList: [
          {
            required: true,
            message: "请选择人员",
            trigger: "change",
          },
        ],
        workShopDirectorPhone: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
          {
            validator: (rule, value, callback) => {
              var reg = new RegExp("^1[3456789]\\d{9}$");
              if (!reg.test(value)) {
                callback(new Error("手机格式错误"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        workShopLeader: [
          {
            required: true,
            message: "请输入班组长姓名",
            trigger: "blur",
          },
        ],
        workShopLeaderPhone: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
          {
            validator: (rule, value, callback) => {
              let reg = new RegExp("^1[3456789]\\d{9}$");
              if (!reg.test(value)) {
                callback(new Error("手机格式错误"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        workShopTelephone: [
          {
            required: true,
            message: "请输固定电话",
            trigger: "blur",
          },
          {
            validator: (rule, value, callback) => {
              let reg = new RegExp(/^\d{3}-\d{7,8}|\d{4}-\d{7,8}$/);
              // let reg = new RegExp("^1[3456789]\\d{9}$");
              if (!reg.test(value)) {
                callback(new Error("固话格式错误"));
              } else {
                callback();
              }
            },
          },
        ],
      },
      type: 1,
    };
  },
  created() {
    // this.formData = [
    // ]
  },
  methods: {
    checkChange(data, checkedData) {
      let checkedArr = checkedData.checkedNodes;
      for (let i = checkedArr.length - 1; i >= 0; i--) {
        if (checkedArr[i].subBuildingList.length > 0) {
          checkedArr.splice(i, 1);
        }
      }
      this.buildingList = checkedArr.map((el) => {
        return {
          buildingCode: el.buildingCode,
          buildingName: el.buildingName,
          parentBuildingName: el.parentName,
        };
      });
    },
    filterNode(value, data) {
      if (!value) {
        return true;
      }
      return data.buildingName.indexOf(value) !== -1;
    },
    cancleOpt() {
      this.buildingList = [];
      this.showBuilding = false;
    },
    confirmOpt() {
      this.form.workShopGroupBuildingList = this.buildingList;
      this.showBuilding = false;
    },
    openPeople() {
      this.key += 1;
      let workShopMonitorArr = this.form.workShopGroupLeaderList.map((el) => {
        return {
          name: el.personnelName,
          personnelCode: el.personnelCode,
          phone: el.personnelPhone,
        };
      });
      this.$nextTick(() => {
        this.$refs.selectPeople.open(workShopMonitorArr, "select");
      });
    },
    // 人员选择回调
    confirmCallBack(data) {
      let personnelList = data.map((el) => {
        return {
          personnelName: el.name,
          personnelPhone: el.phone,
          personnelCode: el.personnelCode,
        };
      });
      this.form.workShopGroupLeaderList = personnelList;
    },
    openBuilding() {
      this.showBuilding = true;
      this.$fetch(api.queryBuildingTree).then((res) => {
        const result = res.returnObj;
        this.treeData = Object.freeze(result);
        this.expandedKeys = this.expandedKeys.length
          ? this.expandedKeys
          : [this.treeData[0].id];
        //选中回显
        let showData = this.form.workShopGroupBuildingList.map((el) => {
          return el.buildingCode;
        });
        this.$refs.tree.setCheckedKeys(showData || []);
      });
    },
    show(groupInfo, type) {
      this.type = type;
      this.showDialog = true;
      this.$nextTick(() => {
        if (type == 1) {
          let { parentCode } = groupInfo;
          this.parentCode = parentCode;
        } else {
          let { parentCode, ...form } = groupInfo;
          this.form = form;
          this.parentCode = parentCode;
          this.workShopGroupCode = groupInfo.workShopGroupCode;
        }
      });
    },
    async save() {
      try {
        const valid = await this.$refs.form.validate();
        if (!valid) return;
        const params =
          this.type === 2
            ? { workShopGroupCode: this.workShopGroupCode, ...this.form }
            : {
                parentCode: this.parentCode,
                ...this.form,
              };
        const realApi =
          this.type === 1 ? api.addWorkShopGroup : api.updateWorkShopGroup;
        const { success, msgContent } = await this.$fetch(realApi, params);
        if (success) {
          this.cancel();
          this.$emit("refresh-workshop-tree");
        } else {
          this.$message.warning(msgContent);
        }
      } catch (error) {
        console.error(error);
      }
    },
    cancel() {
      this.$refs.form.resetFields();
      console.log(this.$refs.form);
      this.showDialog = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.map-choose {
  position: absolute;
  right: 0px;
  font-size: 18px;
}
</style>
